import { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { BrandLogo } from './BrandLogo';

const NAV_LINKS = [
  { to: '/tarot-consultation', label: '타로상담' },
  { to: '/cocktail-menu', label: '메뉴' },
  { to: '/night-community', label: '커뮤니티' },
  { to: '/education-consulting', label: '클래스·컨설팅' },
  { to: '/archive', label: '아카이브' },
  { to: '/visit', label: '방문안내' }
];

export function SiteHeader() {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  return (
    <header className="tm-header">
      <div className="tm-header-inner">
        <Link to="/" className="tm-logo" aria-label="타로맨스 홈">
          <BrandLogo />
        </Link>
        <nav className="tm-nav" aria-label="주요 메뉴">
          {NAV_LINKS.map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              className={({ isActive }) => (isActive ? 'tm-nav-link is-active' : 'tm-nav-link')}
            >
              {link.label}
            </NavLink>
          ))}
        </nav>
        <Link to="/reserve" className="tm-nav-cta">예약하기</Link>
        <button
          type="button"
          className="tm-menu-toggle"
          aria-label={menuOpen ? '메뉴 닫기' : '메뉴 열기'}
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen((open) => !open)}
        >
          {menuOpen ? (
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round">
              <path d="M5 5l14 14M19 5L5 19" />
            </svg>
          ) : (
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round">
              <path d="M4 7h16M4 12h16M4 17h16" />
            </svg>
          )}
        </button>
      </div>
      <div className={menuOpen ? 'tm-mobile-menu is-open' : 'tm-mobile-menu'}>
        {NAV_LINKS.map((link) => (
          <NavLink
            key={link.to}
            to={link.to}
            className={({ isActive }) => (isActive ? 'is-active' : undefined)}
          >
            {link.label}
          </NavLink>
        ))}
        <Link to="/reserve">예약하기</Link>
      </div>
    </header>
  );
}
